import Vue from 'vue';
import SkyCrop from './sky-crop';

// Main component
Vue.component('sky-crop', SkyCrop);

export default SkyCrop;



// WEBPACK FOOTER //
// ./scripts/sky-crop/index.js